import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router';

import AdminTitle from '../../components/AdminTitle';
import Api from '../../Api';

import moment from 'moment';

import './Orders.less';

function findWithToken(token, list) {
  return list.find(item => item.token === token);
}

export default class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.state = Object.assign(
      {
        orders: null,
        error: null,
        retailerFilter: null,
        brandFilter: null
      },
      Api.cache.getOrderList() || {}
    );
  }

  componentWillMount() {
    if (!this.state.orders) {
      this.loadOrders();
    }
  }

  loadOrders() {
    Api.getOrders().then(orders => {
        this.setState(orders);
      })
      .catch(error => {
        this.setState({error});
      });
  }

  onChange(event) {
    let payload = {};
    payload[event.target.name] = event.target.value;
    this.setState(payload)
  }

  render() {
    if (this.state.error) {
      console.error(this.state.error);
      return <div className="error">Error: {this.state.error.message}</div>;
    }

    let orders;
    if (!this.state.orders) {
      orders = <FontAwesome name="refresh" spin />;
    } else {
      let orderList = this.state.orders;

      // Filter retailer
      if (this.state.retailerFilter) {
        orderList = orderList.filter(order => {
          return (order.retailer_token === this.state.retailerFilter);
        });
      }

      // Filter brand
      if (this.state.brandFilter) {
        orderList = orderList.filter(order => {
          let i;
          for (i = 0; i < order.items.length; i++) {
            if (order.items[i].brand_token === this.state.brandFilter) return true;
          }

          return false;
        });
      }

      orders = orderList.map((order) => {
        return <OrderItem key={order.token} order={order} retailers={this.state.retailers} users={this.state.users} loadOrders={this.loadOrders} />
      });
    }

    let retailerFilter = null;
    if (this.state.retailers) {
      let retailerOptions = [ <option key='retailerfilter-option-none' value="">-</option> ];

      this.state.retailers
      .sort((a, b) => {
        return(a.name.localeCompare(b.name));
      })
      .forEach(
        retailer => {
          retailerOptions.push(
            <option key={'retailerfilter-option-' + retailer.token} value={retailer.token}>
              {retailer.name}
            </option>
          );
        }
      );
      retailerFilter = <span><label>Retailer</label> <select name="retailerFilter" onChange={this.onChange}>{retailerOptions}</select></span>;
    }

    let brandFilter = null;
    if (this.state.brands) {
      let brandOptions = [ <option key='brandfilter-option-none' value="">-</option> ];

      let brandList = Object.keys(this.state.brands).map(
        brand_key => {
          return this.state.brands[brand_key];
        }
      );

      brandList
      .sort((a, b) => {
        return a.name.localeCompare(b.name);
      })
      .forEach(
        brand => {
          brandOptions.push(
            <option key={'brandFilter-option-' + brand.token} value={brand.token}>
              {brand.name}
            </option>
          );
        }
      );
      brandFilter = <span><label>Brand</label> <select name="brandFilter" onChange={this.onChange}>{brandOptions}</select></span>;
    }

    return (
      <div className="order-list">
        <AdminTitle title="Placed Orders" />
        <div className="order-filter">
          {retailerFilter}
          {brandFilter}
        </div>
        {orders}
      </div>
    );
  }
}

export class OrderItem extends React.Component {
  constructor(props) {
    super(props);

    this.onCancelOrder = this.onCancelOrder.bind(this);
    this.getCancelOrderSpan = this.getCancelOrderSpan.bind(this);
  }

  onCancelOrder() {
    let orderAmount = parseFloat(this.props.order.total_amount_cents / 100);
    let retailer = findWithToken(this.props.order.retailer_token, this.props.retailers) || {};

    let choice = confirm("Are you sure you want to CANCEL the $" + orderAmount + " order for " + retailer.name + "?");
    if (choice === true) {
      Api.cancelOrder(this.props.order.token)
      .then(
        () => { return this.props.loadOrders(); },
        (error) => { alert('Error canceling order: ' + error.message); }
      );
    }
  }

  getCancelOrderSpan() {
    if (this.props.order.state === 'CANCELED' || this.props.order.state === 'FAILED') return <span className="cancel" />;

    for (let i = 0; i < this.props.order.items.length; i++) {
      let item = this.props.order.items[i];
      if (item.state !== 'WAITING_ON_ORDER' && item.state !== 'CANCELED') return <span className="cancel" />;
    }

    return (
      <span className="cancel" onClick={this.onCancelOrder}>
        <FontAwesome name="remove"/>
      </span>
    );
  }

  render() {
    let order = this.props.order;
    if (!order) return null;

    let retailer = findWithToken(order.retailer_token, this.props.retailers) || {};
    let user = findWithToken(order.user_token, this.props.users) || {};
    let cancelOrder = this.getCancelOrderSpan();
    let orderTotalCents = order.items_amount_cents;
    if (order.shipping_amount_cents) orderTotalCents += order.shipping_amount_cents;
    if (order.total_amount_cents) orderTotalCents += order.total_amount_cents;

    let orderDate = moment(order.created_at);

    return (
      <div className="order-list-entry">
        <span className="retailer">
          <Link to={`/admin/orders/${order.token}`}>{retailer.name}</Link>
        </span>
        <span className="user">{user.name}</span>
        <span className="itemcount">{order.items.length} items</span>
        <span className="orderdate">{orderDate.format('MMM Do YY')}</span>
        <span className="state">{order.state}</span>
        <span className="price">${parseFloat(orderTotalCents / 100).toFixed(2)}</span>
        {cancelOrder}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/Orders.js
 **/